import { type PendingAutoSmartResize, useEditCanvasStore } from '../store';

/**
 * Queues one smart-resize run for an image node; `QueuedSmartResizeRunner` sends it once the node
 * is on the canvas with its media. Call it after the target canvas is active: a canvas switch or
 * `resetForNewDraft` clears the queue. The image chat opener skips the node only while the run is
 * still queued, so callers that need a longer claim set `nullStateOutcomeChatNodeId` themselves.
 */
export const queueSmartResizeForImageNode = (pendingAutoSmartResize: PendingAutoSmartResize) => {
  useEditCanvasStore.getState().setPendingAutoSmartResize(pendingAutoSmartResize);
};
